
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import API from '@/lib/API';

@Component
export default class EcobonusCheckResetDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false

  valid = false

  loading = false

  update = {
    owners: [],
  } as {
    owners: number[];
  }

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get user() {
    return this.$store.getters.currentUser;
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  onCancel() {
    this.dialog = false;
  }

  async onReset() {
    await API.resetEcobonusCheck(this.lead.id);

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
